import { Component, type ErrorInfo, type ReactNode } from "react";

// 전역 에러 경계 — 하위 트리 렌더 중 throw가 나도 루트가 언마운트되어
// "영구 흰화면"이 되는 것을 막고, 복구 가능한 fallback UI를 보여준다.
// (2026-06-13 진단 P1: 커밋 ab246cf TDZ 버그가 흰화면을 실증 — @ts-nocheck 67파일 환경의 보험)
interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // 콘솔 로깅 (추후 원격 수집 훅 연결 지점)
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  private handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    // fallback UI — 디자인 토큰 의존 없이 중립 인라인 스타일만 사용
    return (
      <div
        style={{
          minHeight: "100dvh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          padding: 24,
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 44 }}>🐂</div>
        <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>
          일시적인 오류가 발생했어요
        </h2>
        <p style={{ fontSize: 14, opacity: 0.7, margin: 0, lineHeight: 1.5 }}>
          화면을 다시 불러오면 대부분 해결됩니다.
        </p>
        {/* 원인 1줄 — 실기(WKWebView)에선 콘솔을 볼 수 없어 이 문구가 유일한 단서다(2026-09-03 SE3 실기 오류 추적 불가 사고).
            스택은 노출하지 않고 message만. 사용자가 이 줄을 그대로 전달하면 재현 없이 원인을 좁힐 수 있다. */}
        {this.state.error?.message && (
          <p style={{ fontSize: 11, opacity: 0.45, margin: 0, lineHeight: 1.4, wordBreak: "break-all", maxWidth: 320, fontFamily: "ui-monospace, monospace" }}>
            {String(this.state.error.message).slice(0, 160)}
          </p>
        )}
        <button
          onClick={this.handleReload}
          style={{
            marginTop: 8,
            padding: "10px 22px",
            borderRadius: 10,
            border: "1px solid currentColor",
            background: "transparent",
            color: "inherit",
            fontSize: 15,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          다시 불러오기
        </button>
      </div>
    );
  }
}
